import Cleave from 'cleave.js';

const tinSelector = '[data-cleave-tin]';

if (document.querySelector(tinSelector)) {
    new Cleave(tinSelector, {
        numericOnly: true,
        blocks: [9],
    });
}
